import React from 'react'
import DP, { registerLocale } from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import fr from 'date-fns/locale/fr'
import styled from 'styled-components'

import { Input } from './Input'

registerLocale('fr', fr)

export const DateInput = ({ onChange, value, ...props }) => {
  const finalOnSelect = (val) => {
    const date = new Date(val)
    onChange(date.getTime())
  }
  const finalValue = value && new Date(value)

  return (
    <Wrapper>
      <DP
        {...props}
        onSelect={finalOnSelect}
        dateFormat="dd/MM/yyyy"
        selected={finalValue}
        placeholderText="pickDatePlaceholder"
        wrapperClassName="wrapperClassName"
        customInput={<Input />}
        locale="fr"
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  .wrapperClassName {
    width: 100%;
  }
`
